import React, { useState } from 'react';
import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import { useActiveComponent } from '../../Components/ActiveComponentContext.js/index.jsx';
import RetrievePost from '../../Components/RetrievePost/index.jsx';
import RetrieveAd from '../../Components/RetrieveAd/index.jsx';
import Grid from '@mui/material/Grid';
import { useMediaQuery, useTheme } from '@mui/material';
import { drawerList } from '../../Data/pageData.jsx';
import GridViewIcon from '@mui/icons-material/GridView';
import IconButton from '@mui/material/IconButton';
import ViewStreamIcon from '@mui/icons-material/ViewStream';
import ViewHeadlineIcon from '@mui/icons-material/ViewHeadline';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import ViewAgendaIcon from '@mui/icons-material/ViewAgenda';
import { categoryList } from '../../Data/pageData.jsx';
import SearchBar from '../../Components/SearchBar/index.jsx';

const CategoryPageDisplay = ({ categoryName, isFeatured }) => {
  const { backgroundColor } = useActiveComponent();

  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));

  // State to track if there are ads to display
  const [hasAds, setHasAds] = useState(false);
  const [isGridView, setIsGridView] = useState(true);

  const handleAdsExistence = (adsExist) => {
    setHasAds(adsExist);
  };
  // const getCategoryIcon = (categoryName) => {
  //   const drawerItem = drawerList.find((item) => item.name === categoryName);
  //   return drawerItem ? drawerItem.icon : null;
  // };
  const getCategoryIcon = (categoryName) => {
    const categoryItem = categoryList.find(
      (item) => item.name === categoryName
    );
    return categoryItem ? categoryItem.icon : null;
  };

  const fontColor = backgroundColor === '#ffffff' ? '#030202' : 'lightgrey';
  return (
    <>
      <Box
        sx={{
          height: '100vh', // Full viewport height
          overflowY: 'auto', // Enable vertical scrolling of entire homepage
        }}
      >
        {/* Sticky header section with Typography and Tabs */}
        <Box
          sx={{
            position: 'sticky',
            top: 0,
            zIndex: 1000, // Ensure it's above other content while scrolling
            backgroundColor: backgroundColor, // Set background so it's visible while scrolling
            p: 0.5,
          }}
        >
          <Box
            sx={{
              display: { xs: 'flex', sm: 'flex', lg: 'none', xl: 'none' },
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'white',
              pb: 0.5,
              height: 45,
              ml: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
              position: 'sticky',
              top: 0,
              zIndex: 1000, // Ensure it's above other content while scrolling
            }}
          >
            <SearchBar width={300} />
          </Box>
          <Box
            p={0}
            mt={2}
            mb={3}
            sx={{
              position: 'relative', // Enables absolute positioning for children
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              height: '30px', // Adjust the height as needed
            }}
          >
            {/* <Typography sx={{}}> </Typography> */}
            <Typography
              variant='h2'
              noWrap
              component='div'
              sx={{
                position: 'absolute', // Positioning absolute for perfect centering
                left: '50%', // Align it to the middle of the container
                transform: 'translateX(-50%)', // Correct the offset from left 50%
                display: { xs: 'flex', md: 'flex' },
                alignItems: 'center',
                gap: 1.5,
                mb: 4,
                mt: 3,
                fontFamily: 'Raleway Dots, cursive',
                textShadow: '0px 0px 0.7px black',
                fontWeight: { xs: 1000, md: 700 },
                letterSpacing: '.3rem',
                fontSize: { xs: 12, sm: 12, md: 13, lg: 15, xl: 15 },
                flexDirection: 'center',
                color: fontColor,
                textDecoration: 'none',
                cursor: 'pointer', // Change cursor to pointer to indicate it's clickable
              }}
            >
              {getCategoryIcon(categoryName)} {categoryName}
            </Typography>
            <IconButton
              disableRipple
              sx={{
                ml: 'auto',
                mr: '4%',
                mt: 6,
                mb: 1,
                '&:hover': { color: 'black' },
              }}
              onClick={() => setIsGridView(!isGridView)}
            >
              {isGridView ? (
                <ViewAgendaIcon sx={{ fontSize: 25 }} />
              ) : (
                <ViewModuleIcon sx={{ fontSize: 26 }} />
              )}
            </IconButton>
          </Box>
        </Box>
        <Box sx={{ mt: 1 }}>
          <RetrievePost
            selectedCategory={categoryName}
            isFeatured={isFeatured}
            isGridView={isGridView}
          />
        </Box>
      </Box>
    </>
  );
};

export default CategoryPageDisplay;
